/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * GetDocument.Insider
 * OpenAPI spec version: 1.0.0
 */

export type DocumentProcessingReceiptIntakeStatus =
    (typeof DocumentProcessingReceiptIntakeStatus)[keyof typeof DocumentProcessingReceiptIntakeStatus];

export const DocumentProcessingReceiptIntakeStatus = {
    Accepted: 'Accepted',
    Duplicate: 'Duplicate',
    Invalid: 'Invalid',
    Failed: 'Failed',
    Blocked: 'Blocked',
} as const;
